import { render, staticRenderFns } from "./pay_pc.vue?vue&type=template&id=207a9942&scoped=true&"
import script from "./pay_pc.vue?vue&type=script&lang=js&"
export * from "./pay_pc.vue?vue&type=script&lang=js&"
import style0 from "./pay_pc.vue?vue&type=style&index=0&id=207a9942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a9942",
  null
  
)

export default component.exports